import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {dwhGeneralReport, dwhDashboardReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import {
  dwhGeneralReport as dwhCustomerGeneralReport,
  DwhActionType as DwhCustomerActionType,
  DWHMessageText as DWHCustomerMessageText,
} from '../../OwnershipTransferCustomerBlock/Reports/dwhReports';
import errorIcon from '../Icons/error.svg';

const CustomerValidationResult = (props) => {
  const {title, titleJet, secondTitle, secondTitleJet, buttonText, secondButtonText, icon, report} = props.popupData;

  const popupTitle = props.data.jetConnection && titleJet?.trim() ? titleJet : title;
  const popupSecondTitle = props.data.jetConnection && secondTitleJet?.trim() ? secondTitleJet : secondTitle;

  useEffect(() => {
    dwhReportOnLoad();
  }, [props.popupData]);

  function replacePlaceholders(template) {
    if (isMobile) {
      template = template.replace(/<br\s*\/?>/gi, ''); // Remove all <br> tags if isMobile is true
    }
    return template.replace(/{(\w+)}/g, (match, key) => {
      const value = props.data[key];
      if (typeof value === 'string' && value.startsWith('05')) {
        return styledNumber(value);
      }
      return value || match;
    });
  }

  const styledNumber = (number) => {
    return number?.replace(/^(.{3})(.*)$/, '$1-$2');
  };

  function dwhReportOnLoad() {
    switch (report) {
      case 'cancelTransferEnsurePopupDisplayed':
        dwhDashboardReport({
          data: {
            row: props.data.dashboardData.find((r) => r.id == props.data.requestId),
            userDetails: props.userDetails,
            portalsBlock: props.portalsBlock,
          },
          actionType: DwhActionType.StatusTable,
          messageText: DWHMessageText.CancelTransferEnsurePopupDisplayed,
          status: DWHStatus.Ongoing,
        });
        break;
      case 'cancelSuccess':
        dwhDashboardReport({
          data: {
            row: props.data.dashboardData.find((r) => r.id == props.data.requestId),
            userDetails: props.userDetails,
            portalsBlock: props.portalsBlock,
          },
          actionType: DwhActionType.StatusTable,
          messageText: DWHMessageText.CancelTransferSuccessScreen,
          status: DWHStatus.Ongoing,
        });
        break;
      case 'inProgress':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorAlreadyExistsTransferRequest,
          status: DWHStatus.Error,
        });
        break;
      case 'memberOfDifferentOrg':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorNotInOrganizationAnotherOrganization,
          status: DWHStatus.Error,
        });
        break;
      case 'accountNotFound':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorNotInOrganization,
          status: DWHStatus.Error,
        });
        break;
      case 'errorSubStatus':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorLineOwnerPostponed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorNPStatus':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorLineOwnerBNIYOD,
          status: DWHStatus.Error,
        });
        break;
      case 'errorAbroad':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.ErrorLineOwnerIsAbroad,
          status: DWHStatus.Error,
        });
        break;
      case 'dataAccount':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock},
          actionType: DwhActionType.LineSearchPage,
          messageText: DWHMessageText.PopupDataLineDisplayed,
          status: DWHStatus.Ongoing,
        });
        break;
      case 'waitingForSignature':
        dwhCustomerGeneralReport({
          data: {...props.customerData, userDetails: props.userDetails},
          actionType: DwhCustomerActionType.PopupNoSignature,
          messageText: DWHCustomerMessageText.PopupNoSignatureDisplayed,
          status: DWHStatus.Ongoing,
        });
        break;
      default:
        break;
    }
  }
  function dwhReportOnSecondButtonClick() {
    switch (report) {
      case 'cancelTransferEnsurePopupDisplayed':
        dwhDashboardReport({
          data: {
            row: props.data.dashboardData.find((r) => r.id == props.data.requestId),
            userDetails: props.userDetails,
            portalsBlock: props.portalsBlock,
          },
          actionType: DwhActionType.StatusTable,
          messageText: DWHMessageText.CancelTransferEnsurePopupButtonClicked,
          status: DWHStatus.Ongoing,
        });
        break;
      default:
        break;
    }
  }

  function submitButtonClick() {
    props.buttonClick();
  }
  function submitSecondButtonClick() {
    dwhReportOnSecondButtonClick();
    props.secondButtonClick();
  }

  return (
    <div className='messagePopup'>
      <Image src={icon ? icon : errorIcon} />
      <div className='l-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(popupTitle)}} />
      {popupSecondTitle && <div className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(popupSecondTitle)}} />}

      <div className='buttons'>
        {secondButtonText && <BtnWhiteBlackBorderBigSize text={secondButtonText} onclick={() => submitSecondButtonClick()} />}
        <BtnSubmit className={`${secondButtonText && !isMobile ? 'in-row' : ''}`} text={buttonText} onclick={() => submitButtonClick()} />
      </div>
    </div>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  customerData: state.OwnershipTransferCustomer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});
export default connect(mapStateToProps, mapDispatchToProps)(CustomerValidationResult);
